export default function onLoadSetup(envVars = {}) {
  const { SETTLD_ENV, GA_ID = "", GTM_ID = "" } = envVars;

  try {
    window.settldTestModeEnabled = !!window.localStorage.getItem("settldTestModeEnabled");
  } catch (e) {
    console.log("onLoadSetup", e);
    window.settldTestModeEnabled = false;
  }
  loadGTM(SETTLD_ENV, GTM_ID);
  loadGoogleAnalytics(GA_ID);
  addScrollToTop();
  loadHotJar(SETTLD_ENV);
}

/**
 * loadGTM - Loads Google Analytics script.
 *
 * @param {string} APP_ENV - staging or production
 * @param {string} GTM_ID - Google Tag Manager ID
 * @returns {void}
 */
function loadGTM(APP_ENV, GTM_ID) {
  if (!GTM_ID) {
    console.warn("GTM_ID not found in environment variables");
    return;
  }
  if (APP_ENV === "production" || APP_ENV === "staging") {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", GTM_ID);

    const noscriptFrame = document.createElement("noscript");
    noscriptFrame.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscriptFrame, document.body.firstChild);
  }
}

/**
 * loadGoogleAnalytics - Loads Google Analytics script.
 * @param {string} GA_ID - Google Analytics ID
 * @returns {void}
 */
function loadGoogleAnalytics(GA_ID) {
  if (!GA_ID) {
    console.warn("GA_ID not found in environment variables");
    return;
  }

  (function () {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      /* eslint-disable-next-line no-undef */
      dataLayer.push(arguments);
    }

    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID);
  })();
}
/**
 * Adds event listener to scroll to top on page load.We have our express website
 * embedded in an iframe which is in wordpress site.
 *
 * @returns {void}
 */
function addScrollToTop() {
  window.addEventListener("message", function (event) {
    if (event.origin !== "https://www.settld.care") {
      return;
    }

    if (event.data !== "settld:resizeIframeSignal") {
      return;
    }

    const parent = event.source;

    setInterval(function () {
      parent.postMessage(
        {
          type: "settld:scrollHeight",
          scrollHeight: document.documentElement.scrollHeight,
        },
        "https://www.settld.care"
      );
    }, 1000);
  });
}
/**
 * loadHotJar - Loads HotJar script.
 *
 * @param {string} SETTLD_ENV - staging or production
 * @returns {void}
 */
function loadHotJar(SETTLD_ENV) {
  if ((SETTLD_ENV === "production" || SETTLD_ENV === "staging") && !window.settldTestModeEnabled) {
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 2157547, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
  }
}
